import { Dispatch } from 'redux';
import {
    getReportsSuccess,
    getReportsFailure,
    getReportsRequest,
    cleanReports as cleanReportsReducer
} from '../reducers/reports';
import { axiosClient } from '../config/axios';
import { api } from '../config/api';
import { unauthorized } from '../reducers/unauthorized';
import { GetState } from '../config/store';

export const getGeneralReport = (startDate: string, endDate: string) => (dispatch: Dispatch, getState: GetState) => _getGeneralReport(startDate, endDate, dispatch, getState);
const _getGeneralReport = async (startDate: string, endDate: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getReportsRequest, payload: "general" });
        
        const response = await axiosClient.get(`${api.leads}/reports?startDate=${startDate}&endDate=${endDate}`, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `reporte_general_leads_${startDate}_${endDate}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        dispatch({ 
            type: getReportsSuccess, 
            payload: { 
                type: 'general',
                data: {
                    downloadUrl,
                    filename: `reporte_general_leads_${startDate}_${endDate}.xlsx`,
                    startDate,
                    endDate
                }
            }
        });

    } catch (error: any) {
        console.log("getGeneralReport error", error.status);
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: getReportsFailure });
    }
};

export const getDealershipReport = (dealershipId: string, startDate: string, endDate: string, comeFrom: string) => (dispatch: Dispatch, getState: GetState) => _getDealershipReport(dealershipId, startDate, endDate, comeFrom, dispatch, getState);
const _getDealershipReport = async (dealershipId: string, startDate: string, endDate: string, comeFrom: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getReportsRequest, payload: "dealership" });
        
        const params = new URLSearchParams({
            dealership: dealershipId,
            startDate,
            endDate,
            come_from: comeFrom
        });

        const response = await axiosClient.get(`${api.leads}/reports/by-dealership?${params}`, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `reporte_concesionaria_${dealershipId}_${startDate}_${endDate}_${comeFrom}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        dispatch({ 
            type: getReportsSuccess, 
            payload: { 
                type: 'dealership',
                data: {
                    downloadUrl,
                    filename: `reporte_concesionaria_${dealershipId}_${startDate}_${endDate}_${comeFrom}.xlsx`,
                    dealershipId,
                    startDate,
                    endDate,
                    comeFrom
                }
            }
        });

    } catch (error: any) {
        console.log("getDealershipReport error", error.status);
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: getReportsFailure });
    }
};

export const cleanReports = () => (dispatch: Dispatch) => _cleanReports(dispatch);
const _cleanReports = async (dispatch: Dispatch) => dispatch({ type: cleanReportsReducer });
